import * as React from "react";

interface ChevronProps extends React.SVGProps<SVGSVGElement> {
  direction: "left" | "right" | "up" | "down";
  animated?: boolean;
}

const rotationMap = {
  left: "90deg",
  down: "0deg",
  up: "180deg",
  right: "270deg",
};

const Chevron = (props: ChevronProps) => {
  const style: React.CSSProperties = props.animated ? { transition: "transform 0.4s" } : {};
  const transform: React.CSSProperties["transform"] = `rotate(${rotationMap[props.direction]})`;

  return (
    <span
      style={{ ...props.style, ...style, transform }}
      className={`icon-[mdi--chevron-up] w-[20px] h-[20px] ${props.className}`}
    />
  );
};
export default Chevron;
